module.exports = __webpack_public_path__ + "img/tips-list.f4b7648a.svg";